import { Card } from '@/components/ui/card';
import { BarChart } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

interface TopListsGridProps {
  topProducts: TopItemsData;
  topServiceUsers: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topProducts, topServiceUsers, isLoading }: TopListsGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Product Categories</h3>
        <p className="text-sm text-muted-foreground mb-4">Most frequently handled product categories</p>
        <BarChart data={topProducts} height={300} loading={isLoading} />
      </Card>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Service Users</h3>
        <p className="text-sm text-muted-foreground mb-4">Organizations with highest service volume</p>
        <BarChart data={topServiceUsers} height={300} loading={isLoading} />
      </Card>
    </div>
  );
}
